import React, { useState } from "react";
import { useSpring, animated, easings } from "react-spring";

import iconPlus from '../../Images/IconPlus.svg'
import iconMinus from '../../Images/IconMinus.svg'
import "../componentsStyle.css"
import Regenerate from "../Regenerate/Regenerate";

const UnderDevelopent = (props) => {
    const { showMaximumChat, data, updateMessage, loading , index , messages ,sessionId ,setIsFeedbackPop ,checkThumsDownFeedback } = props


    const fadeInProps = useSpring({
        from: { opacity: Math.random() },
        to: { opacity: 1 },
        config: { duration: 1000, easing: easings.easeInOut },
        // Adjust duration and easing as needed
    });

    

      const renderList = (msg) => {
        const data = msg?.llm_response;
      
        return (
          <div className="channel-list">
            {data && Object.entries(data).map(([packName, channelCount], index) => (
              <div key={index} className="channel-list-head" style={{ marginBottom: '16px', padding: '16px', borderRadius: '8px' }}>
                <div>
                  <p className="channel-list-heading">{packName}</p>
                  {!showMaximumChat && <span className="channel-list-count">{channelCount} Channels</span>}
                </div>
                <div style={{ display: 'flex', gap: '4px' }}>
                  {showMaximumChat && <span style={{ fontWeight: '700' }} className="channel-list-count">{channelCount} Channels</span>}
                </div>
              </div>
            ))}
          </div>
        );
      };
      
      


    return (
        <div className="server-text-response-body">

            {<>
                <div className="channel-list-reponse" style={{ color: '#220046' }}>{data?.llm_response?.Text || data?.text}</div>
                <Regenerate msg={data} fadeInProps={fadeInProps} updateMessage={updateMessage} showMaximumChat={showMaximumChat} setIsFeedbackPop={setIsFeedbackPop} index={index} messages={messages} sessionId={sessionId} checkThumsDownFeedback={checkThumsDownFeedback} showRegenerate={data?.isFailed } />


            </>}

        </div>
    )
}

export default UnderDevelopent
